__turbopack_context__.v({
  "ticker": "ticker-module-scss-module__9uKdhW__ticker",
});
